import { render, staticRenderFns } from "./OpinionSlider.vue?vue&type=template&id=57fa7dd8&scoped=true&"
import script from "./OpinionSlider.vue?vue&type=script&lang=js&"
export * from "./OpinionSlider.vue?vue&type=script&lang=js&"
import style0 from "./OpinionSlider.vue?vue&type=style&index=0&id=57fa7dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa7dd8",
  null
  
)

export default component.exports